module.exports = __webpack_public_path__ + "static/media/logo2_x3.fb81c645.png";